import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import { JobInfoHeaderFieldsFragmentDoc } from './JobInfoHeaderFragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetJobInfoHeaderDataQueryVariables = Types.Exact<{
    input: Types.FindReviewBeforeSubmitDraftInput;
}>;

export type GetJobInfoHeaderDataQuery = {
    __typename?: 'Query';
    findReviewBeforeSubmitDraft?:
        | {
              __typename?: 'FindReviewBeforeSubmitDraftPayload';
              draft: {
                  __typename?: 'AutoApplyDraft';
                  applicationDraftId: string;
                  iaUid: string;
                  jobTitle: string;
                  jobLocation: string;
                  employerName?: string | null | undefined;
                  applyableJob: {
                      __typename?: 'ReviewBeforeSubmitApplyableJob';
                      clientJobRef?: string | null | undefined;
                  };
              };
          }
        | null
        | undefined;
};

export const GetJobInfoHeaderDataDocument = gql`
    query GetJobInfoHeaderData($input: FindReviewBeforeSubmitDraftInput!) {
        findReviewBeforeSubmitDraft(input: $input) {
            draft {
                ...JobInfoHeaderFields
            }
        }
    }
    ${JobInfoHeaderFieldsFragmentDoc}
`;

/**
 * __useGetJobInfoHeaderDataQuery__
 *
 * To run a query within a React component, call `useGetJobInfoHeaderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobInfoHeaderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobInfoHeaderDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetJobInfoHeaderDataQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetJobInfoHeaderDataQuery,
        GetJobInfoHeaderDataQueryVariables
    > &
        ({ variables: GetJobInfoHeaderDataQueryVariables; skip?: boolean } | { skip: boolean }),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetJobInfoHeaderDataQuery, GetJobInfoHeaderDataQueryVariables>(
        GetJobInfoHeaderDataDocument,
        options,
    );
}
export function useGetJobInfoHeaderDataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetJobInfoHeaderDataQuery,
        GetJobInfoHeaderDataQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetJobInfoHeaderDataQuery, GetJobInfoHeaderDataQueryVariables>(
        GetJobInfoHeaderDataDocument,
        options,
    );
}
export function useGetJobInfoHeaderDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetJobInfoHeaderDataQuery,
              GetJobInfoHeaderDataQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetJobInfoHeaderDataQuery, GetJobInfoHeaderDataQueryVariables>(
        GetJobInfoHeaderDataDocument,
        options,
    );
}
export type GetJobInfoHeaderDataQueryHookResult = ReturnType<typeof useGetJobInfoHeaderDataQuery>;
export type GetJobInfoHeaderDataLazyQueryHookResult = ReturnType<
    typeof useGetJobInfoHeaderDataLazyQuery
>;
export type GetJobInfoHeaderDataSuspenseQueryHookResult = ReturnType<
    typeof useGetJobInfoHeaderDataSuspenseQuery
>;
export type GetJobInfoHeaderDataQueryResult = Apollo.QueryResult<
    GetJobInfoHeaderDataQuery,
    GetJobInfoHeaderDataQueryVariables
>;
